import styled from "styled-components";
import {gallery, shark} from "../variables";

export default styled.h2.attrs({className: 'pb-1 pl-2 pt-3'})`
    font-size: 14px;
    color: ${shark};
    border-bottom: 1px solid ${gallery}
`;

